import 'element-closest-polyfill';
import 'bootstrap/js/dist/modal';
import Cookies from 'js-cookie'

import { Validator, nlLang as nl } from "@upjs/facile-validator";
import { gtm } from './gtm.js';

export const townSelector = {
    init: function () {
        this.initSelector();
        this.initWebRing();
    },

    validateMunicipality: function(el){

        const municipalitySelect = $(el).find('#municipality-select');
        if(municipalitySelect){

            let validated = false;
            let municipality = $('#town-selector #municipality-select').val();

            if(municipality > 0){
                validated = true;
            }

            if(validated){
                $(el).find('.btn-selector').removeAttr('disabled');
            }
            else {
                $(el).find('.btn-selector').attr('disabled', true);
            }

            return validated;

        }

    },

    // validPostalCode: function (el){
    //     let val;
    //     let validated = true;
    //     let hasValidationError = false

    //     $(el).find('.postalcode-selector .pincode-input-text').each(function(index) {

    //         index = index + 1;

    //         val = $(this).val();

    //         $(this).removeClass('is-wrong');
    //         let fieldValid = true;

    //         if(val != ''){

    //             let num = isNaN(parseInt(val)) ? false : parseInt(val)

    //             if(index <= 4){
    //                 // First four fields (should be a number)
    //                 if(val == 0){}
    //                 else if (!num) {
    //                     validated = false;
    //                     fieldValid = false;
    //                 }
    //             }
    //             else {
    //                 // First four fields (should be a letter)
    //                 if (num) {
    //                     validated = false;
    //                     fieldValid = false;
    //                 }
    //             }
    //         }
    //         else {
    //             validated = false;
    //         }

    //         if(!fieldValid){
    //             $(this).addClass('is-wrong');
    //             hasValidationError = true;
    //         }
    //     });

    //     if(validated){
    //         $(el).find('.btn-selector').removeAttr('disabled');
    //     }
    //     else {
    //         $(el).find('.btn-selector').attr('disabled', true);
    //     }

    //     if (hasValidationError) {
    //         $(el).find('.postal-code-validation-failed').removeClass('d-none');
    //     } else {
    //         $(el).find('.postal-code-validation-failed').addClass('d-none');
    //     }

    //     return validated;

    // },

    resetPostalCodeInput: function(el){
        // $(el).find('.postalcode-selector .pincode-input-text').val('');
        $(el).find('#postalcode-input').val('');
    },

    initPostalCodeInput: function(el){
        const postalCodeInput = document.querySelector('.postalcode-selector #postalcode-input');

        if (postalCodeInput) {
            postalCodeInput.addEventListener('blur',function(){
                this.value = this.value.replace(/\s+/g,'');
            });

            postalCodeInput.addEventListener('input',function(){
                const errorMessage = document.querySelector('.postalcode-selector .alert-wrong-postalcode');

                this.value = this.value.replace(/\s+/g,'');

                if (errorMessage) {
                    errorMessage.remove();
                }
            });
        }
    },

    initSelector: function (){

        const _self = this;
        _self.initPostalCodeInput();

        const formEl = document.querySelector('#postal-code-form');
        const nlMesssages = { ...nl };

        nlMesssages["required"] = "Dit veld is niet ingevuld";

        const v = new Validator(formEl, {
            lang: nlMesssages,
            onFieldChangeValidation: true,
            xRules: {
                dutchPostalCode: {
                    value: /^[1-9][0-9]{3}\s?[A-Za-z]{2}$/,
                    errorMessage: "De ingevulde postcode is onjuist. Een geldige postcode start met vier cijfers en eindigt met twee letters, bijvoorbeeld 1234AA.",
                },
            }
        });

        formEl.setAttribute("novalidate", "");

        formEl.addEventListener("submit", (evt) => {
            evt.preventDefault();

            v.validate();
        });

        v.on("validation:success", () => {
            const postalcodeEl = formEl.querySelector('#postalcode-input');
            const municipalityEl = formEl.querySelector('#municipality-select');

            let postalcode = postalcodeEl ? postalcodeEl.value : ''
            postalcode = postalcode ? postalcode.toUpperCase() : '';

            const municipality = municipalityEl ? municipalityEl.value : 0;

            let options = {};

            if (formEl.closest('#town-modal-selector')) {
                options =  {
                    'category' : 'modal'
                };
            }

            if(municipality > 0){
                _self.setMunicipalityCookie(municipality);
            }
            else {
                if(postalcode === ''){
                    postalcode = '-1';
                }

                _self.setPostalCodeCookie(postalcode, options);
            }
        });

        v.on('validation:start', (formEl) => {
            const inputFields = formEl.querySelectorAll('input[data-rules]:not([type="hidden"]):not([type="submit"]):not([type="button"]), select[data-rules], textarea[data-rules]') || [];

            inputFields.forEach(inputField => {
                inputField.removeAttribute('aria-invalid');
                inputField.removeAttribute('aria-describedby');
            });
        });

        v.on('field:error', (form, field, errors) => {
            const inputId = field.getAttribute('id') || '';
            const formGroup = field.closest('.form-group');
            const alertEl = formGroup ? formGroup.querySelector('.validator-err') : null;

            console.log(alertEl);

            if (alertEl) {
                alertEl.setAttribute('id', `${inputId}-error`);
                field.setAttribute('aria-describedby', `${inputId}-error`);
            }

            field.setAttribute('aria-invalid', 'true');
        });

        v.on('validation:failed', (formEl) => {
            const inputFields = formEl.querySelectorAll('input[data-rules]:not([type="hidden"]):not([type="submit"]):not([type="button"]), select[data-rules], textarea[data-rules]') || [];
            let focusIsMoved = false;

            inputFields.forEach(inputField => {
            const inputId = inputField.getAttribute('id') || '';
            const formGroup = inputField.closest('.form-group');
            const alertEl = formGroup ? formGroup.querySelector('.validator-err') : null;

            if (!focusIsMoved && alertEl) {
                alertEl.setAttribute('id', `${inputId}-error`);
                inputField.setAttribute('aria-describedby', `${inputId}-error`);
                inputFields[0].focus();
            }

            focusIsMoved = true;
            });
        });


        // set postalcode by submit
        // $(document).on('click','#town-selector .btn-selector', function(e) {

        // });

        // goto-municipality in alert
        $(document).on('click','#town-selector .goto-municipality', function(e) {
            e.preventDefault();
            $('#town-selector #municipality-select').focus();
        });

        // set municipality by select
        $(document).on('change','#town-selector #municipality-select', function(e) {
            e.preventDefault();
            _self.resetPostalCodeInput('#town-selector');
            _self.validateMunicipality('#town-selector');
        });

    },

    initWebRing: function(){

        const _self = this;

        // set municipality by select
        $(document).on('change','#webring .town-selector select', function(e) {
            e.preventDefault();
            const municipality = $(this).val();
            _self.setMunicipalityCookie(municipality, { 'category': 'webring' })
        });

    },

    setPostalCodeCookie: function(postalcode, options){
        Cookies.set('postalcode', postalcode, { expires: 365 });
        this.setMunicipalityByPostalCode(postalcode, options);
    },

    setMunicipalityCookie: function(municipality, options = false){
        Cookies.set('municipality', municipality, { expires: 365 });

        let postalcode = '-1';
        Cookies.set('postalcode', postalcode, { expires: 365 });

        let categoryName = 'inline';

        if(options && options.hasOwnProperty('category')){
            categoryName =  options.category;
        }

        gtm.push({
            'category' : `town-${categoryName}-selector`,
            'action' : 'save',
            'label' : 'municipality',
        });

        window.location.reload(true);

    },

    setMunicipalityByPostalCode: function(postalcode, options = false) {

        $.ajax({
            type: "POST",
            url: "/ajax/municipality/lookup",
            data: JSON.stringify({"postalCode": postalcode}),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function(data) {

                let categoryName = 'inline';
                if(options && options.hasOwnProperty('category')){
                    categoryName =  options.category;
                }

                if(data.municipality == 0){

                    let el = '#town-selector';
                    if(categoryName == 'modal'){
                        el = '#town-modal-selector';
                    }

                    // show alert
                    $(el).find('.result-output').html('<p class="alert-wrong-postalcode">De ingevoerde postcode valt buiten ons gebied. Probeer een andere postcode of kies een <a href="#" class="goto-municipality">gemeente.</a></p>');

                    gtm.push({
                        'category' : `town-${categoryName}-selector`,
                        'action' : 'wrong',
                        'label' : 'postalcode',
                    });

                }
                else {

                    // set municipality cookie
                    Cookies.set('municipality', data.municipality, { expires: 365 });

                    gtm.push({
                        'category' : `town-${categoryName}-selector`,
                        'action' : 'save',
                        'label' : 'postalcode',
                    });

                    window.location.reload(true);
                }


            },
            failure: function(errMsg) {
                return 0;
            }
        });
    }

};
